import React, { useEffect } from "react";

import PropTypes from "prop-types";
import { useParams } from "react-router";
import Spin from "shared/components/Spin";
import { useFolderStatus } from "utils/hooks/folderStatus";

import View from "./View";

const Component = ({ folderStatus, actionCode, onChange }) => {
  const { id } = useParams();
  const { getStatusConfig, code, forms, statusInfo, loading } =
    useFolderStatus();

  useEffect(() => {
    getStatusConfig({
      folderNum: id,
      folderStatus,
      actionCode,
    });
  }, [folderStatus, actionCode]);

  const _onChange = (data) => {
    onChange({ ...data, ...code });
  };

  if (loading) {
    return (
      <div className="center">
        <Spin />
      </div>
    );
  }

  return <View forms={forms} statusInfo={statusInfo} onChange={_onChange} />;
};

Component.propTypes = {
  folder: PropTypes.shape({
    productCode: PropTypes.string,
    folderNum: PropTypes.string.isRequired,
  }),
  folderStatus: PropTypes.shape({
    processCode: PropTypes.string,
    statusCode: PropTypes.string,
  }).isRequired,
  actionCode: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
export default Component;
